"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.setCookie = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
function setCookie(key, value, options) {
    if (options === void 0) { options = {}; }
    options = __assign({ sameSite: 'none', secure: true, path: '/', expires: 30 }, options);
    js_cookie_1.default.set(key, value, options);
}
exports.setCookie = setCookie;
function getCookie(key) {
    return js_cookie_1.default.get(key);
}
exports.getCookie = getCookie;
